import { bffCommonServiceClient } from '../../packages/request/clients';
import { getResult } from 'helpers/request';

export type OnUploadProgressFunc = (onUploadProgress: ProgressEvent) => void;

const uploadFile = (file: File, onUploadProgress?: OnUploadProgressFunc) => {
  const formData = new FormData();
  formData.append('file', file);
  return bffCommonServiceClient
    .post('/common/upload/minio', formData, {
      headers: {
        'content-type': 'multipart/form-data',
      },
      onUploadProgress: onUploadProgress,
    })
    .then(getResult);
};

const downloadFile = (filePath: string, isThumbnail?: boolean) => {
  return bffCommonServiceClient
    .get(
      `/common/download/minio/${filePath}${
        isThumbnail ? '?isThumbnail=true' : ''
      }`,
      {
        responseType: 'arraybuffer',
      }
    )
    .then(getResult);
};

const downloadFileToDevice = (filePath: string, name: string) => {
  return bffCommonServiceClient
    .get(`/common/download/minio/${filePath}`, {
      responseType: 'arraybuffer',
    })
    .then(response => {
      let a = document.createElement('a');
      document.body.appendChild(a);
      a.style.display = 'none';
      const blob = new Blob([response.data], {
          type: 'application/octet-stream',
        }),
        url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = name;
      a.click();
      window.URL.revokeObjectURL(url);
    });
};

export default { uploadFile, downloadFile, downloadFileToDevice };
